import { CommandIslandPlayground } from "../CommandIslandPlayground";
import { CommandPalettePlayground } from "../CommandPalettePlayground";
import { DetailsAsidePlayground } from "../DetailsAsidePlayground";
import { DrawerPlayground } from "../DrawerPlayground";
import { MenuPlayground } from "../MenuPlayground";
import { ModalPlayground } from "../ModalPlayground";
import { PopoverPlayground } from "../PopoverPlayground";
import { SettingsPanelPlayground } from "../SettingsPanelPlayground";
import { TooltipPlayground } from "../TooltipPlayground";
import type { PlaygroundComponentEntry } from "../playgroundComponents";

export const overlaysEntries: PlaygroundComponentEntry[] = [
    {
        id: "modal",
        label: "Modal",
        description: "Dialog overlay with header, body, and footer.",
        group: "components",
        render: () => <ModalPlayground />,
    },
    {
        id: "drawer",
        label: "Drawer",
        description: "Slide-in panel overlay.",
        group: "components",
        render: () => <DrawerPlayground />,
    },
    {
        id: "popover",
        label: "Popover",
        description: "Anchored floating panel with side and align options.",
        group: "components",
        render: () => <PopoverPlayground />,
    },
    {
        id: "settings-panel",
        label: "Settings panel",
        description:
            "Popover settings shell with the Menu and Picker look: sections, control rows, toggle rows and a pinned footer.",
        group: "components",
        render: () => <SettingsPanelPlayground />,
    },
    {
        id: "details-aside",
        label: "Details aside",
        description: "Structured side panel for record details.",
        group: "components",
        render: () => <DetailsAsidePlayground />,
    },
    {
        id: "command-island",
        label: "Command island",
        description: "Floating action bar for bulk selection actions.",
        group: "components",
        render: () => <CommandIslandPlayground />,
    },
    {
        id: "command-palette",
        label: "Command palette",
        description:
            "⌘K palette chrome with breadcrumb, search, results, and footer slots.",
        group: "components",
        render: () => <CommandPalettePlayground />,
    },
    {
        id: "menu",
        label: "Menu",
        description:
            "Figma-aligned action menu on Base UI: Menu.Root with any trigger, the Menu.More kebab, items, links, submenus, toggle and radio rows, groups and separators.",
        group: "ready-components",
        render: () => <MenuPlayground />,
    },
    {
        id: "tooltip",
        label: "Tooltip",
        description:
            "Plain-text hint with title, bullets or shortcut, per the Figma Tooltip set.",
        group: "ready-components",
        render: () => <TooltipPlayground />,
    },
];
